// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__nyzGH","label":"Input_label__Cj8qV","input":"Input_input__uSoNP","invalid":"Input_invalid__CRs15"};